import { create } from "zustand";
import { createStoreWithSelectors } from "./createStoreWithSelectors";

interface FormState {
  title: string;
  firstName: string;
  lastName: string;
  postcode: string;
  houseNumber: string;
  email: string;
  contactNumber: string;
  message: string;
  signUpToEmail: boolean;
  setTitle: (title: string) => void;
  setFirstName: (firstName: string) => void;
  setLastName: (lastName: string) => void;
  setPostcode: (postcode: string) => void;
  setHouseNumber: (houseNumber: string) => void;
  setEmail: (email: string) => void;
  setContactNumber: (contactNumber: string) => void;
  setMessage: (message: string) => void;
  setSignUpToEmail: (signUpToEmail: boolean) => void;
}

const formInitialValues = {
  title: "",
  firstName: "",
  lastName: "",
  postcode: "",
  houseNumber: "",
  email: "",
  contactNumber: "",
  message: "",
  signUpToEmail: false,
};

const formStore = create<FormState>()((set) => ({
  ...formInitialValues,
  setTitle: (title) => set(() => ({ title })),
  setFirstName: (firstName) => set(() => ({ firstName })),
  setLastName: (lastName) => set(() => ({ lastName })),
  setPostcode: (postcode) => set(() => ({ postcode })),
  setHouseNumber: (houseNumber) => set(() => ({ houseNumber })),
  setEmail: (email) => set(() => ({ email })),
  setContactNumber: (contactNumber) => set(() => ({ contactNumber })),
  setMessage: (message) => set(() => ({ message })),
  setSignUpToEmail: (signUpToEmail) => set(() => ({ signUpToEmail })),
}));

export const useFormStore = createStoreWithSelectors(formStore);
